import { GET } from "../utils/constants";
import { fetchData } from "../utils/dataProvider";
import { ICoverageSummary, IDemandCoverageSummary } from "../interfaces/coverage";

export const getMatrixCoverage = (
  matrixId: string,
  credentialId: string
): Promise<ICoverageSummary> => {
  const params = new URLSearchParams({ credential_id: credentialId });
  return fetchData({ url: `/marketplaces_merchants/getMatrixCoverage/${matrixId}?${params}`, method: GET });
};

export const getMatrixCoverageDemand = (
  matrixId: string,
  credentialId: string,
  from: string,
  to: string
): Promise<IDemandCoverageSummary> => {
  const params = new URLSearchParams({ credential_id: credentialId, from, to });
  return fetchData({ url: `/marketplaces_merchants/getMatrixCoverageDemand/${matrixId}?${params}`, method: GET });
};
